import { apiClient } from './client';
import { DashboardStats } from '../types';

export const statisticsApi = {
  getDashboard: async (): Promise<DashboardStats> => {
    const response = await apiClient.get<DashboardStats>('/statistics/dashboard');
    return response.data;
  },
};
